import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  // const handleNewsletterSubmit = (e) => {
  //   e.preventDefault();
  //   // Add newsletter submission logic here
  // };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <button type="button" onClick={() => handleNavigation('/')}>
                  Home
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => handleNavigation('/about')}
                >
                  Who We Are
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => handleNavigation('/services')}
                >
                  What We Do
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => handleNavigation('/products')}
                >
                  Products & Solutions
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => handleNavigation('/training')}
                >
                  Learn With Us
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => handleNavigation('/careers')}
                >
                  Join Our Team
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => handleNavigation('/contact')}
                >
                  Let&apos;s Connect
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-map-marker-alt" aria-hidden="true" />
                <p>
                  6600 Paige Rd,
                  <br />
                  The Colony, TX  75056
                  <br />
                  USA
                </p>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone-alt" aria-hidden="true" />
                <button
                  type="button"
                  className="phone-button"
                  onClick={() => window.location.href = 'tel:+14692624000'}
                >
                  +1 (945) 249-7292
                </button>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope" aria-hidden="true" />
                <button
                  type="button"
                  className="email-button"
                  onClick={() =>
                  (window.location.href =
                    'mailto:info@sradhatech.com')
                  }
                >
                  info@sradhatech.com
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Sradha Technologies LLC. All
            rights reserved.
          </p>
          <div className="footer-bottom-links">
            <button
              type="button"
              onClick={() => handleNavigation('/unsubscribe')}
              className="footer-legal-link"
            >
              Unsubscribe
            </button>
            <button
              type="button"
              onClick={() => handleNavigation('/privacy-policy')}
              className="footer-legal-link"
            >
              Privacy Policy
            </button>
            <button
              type="button"
              onClick={() => handleNavigation('/terms-of-service')}
              className="footer-legal-link"
            >
              Terms and Conditions
            </button>
            <a
              href="https://www.linkedin.com/company/sradhatech"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-legal-link footer-linkedin"
              aria-label="Visit our LinkedIn page"
            >
              <i className="fab fa-linkedin" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
